import { render, staticRenderFns } from "./MisDatosComponent.vue?vue&type=template&id=45ba701e&scoped=true&"
import script from "./MisDatosComponent.vue?vue&type=script&lang=ts&"
export * from "./MisDatosComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MisDatosComponent.vue?vue&type=style&index=0&id=45ba701e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba701e",
  null
  
)

export default component.exports